// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2bbJw","left":"StickyBox_left__VOVLJ","right":"StickyBox_right__1Opqo"};